import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#E2E7F0"
      d="M6 5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v22a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"
    />
    <path
      fill="#8F9BA8"
      d="M16 16h-2a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2M16 18a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2zM16 20a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2zM16 20h2a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2"
    />
    <path
      fill="#8F9BA8"
      fillRule="evenodd"
      d="M5 5a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v22a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zm20 0h-6.764A3 3 0 0 1 19 7v3a2 2 0 0 1-2 2h1a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2h-1a2 2 0 0 1-2-2V7c0-.768.289-1.47.764-2H7v22h18zm-10 5h2V7a1 1 0 1 0-2 0z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconFileCompressed = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconFileCompressed);
export default Memo;
